// „Вижда след" на монитора (Конфигурация → Монитори): от кой кухненски
// статус нататък редът се вижда на екрана, ВКЛЮЧИТЕЛНО. Общо за екрана
// (табовете и брояча на шпикера и сервитьорския) и за Конфигурация (изборът
// и таблицата).
import type { KitchenStatus } from "../../api/monitors";

// Кухненските статуси във възходящ ред: Незапочнато → В процес → Сготвено →
// Издадено. Низовете се сравняват директно ("0" < "1" < "2" < "3").
export const KITCHEN_STATUSES: readonly KitchenStatus[] = ["0", "1", "2", "3"];

export const isKitchenStatus = (value: unknown): value is KitchenStatus =>
  KITCHEN_STATUSES.includes(value as KitchenStatus);

// „Издадено" ("3") поставя самият шпикер при „Изпълни" — той не може да
// вижда едва след него (табът „Неизпълнени" би бил винаги празен).
const SHPICKER_LAST_VISIBLE_FROM: KitchenStatus = "2";

// Ефективното „вижда след" на шпикера. Отговор без `visibleFromStatus` (стар
// BE, старо огледало на касата) → досегашният булев „Всички статуси": true →
// "0", иначе "2" („Само сготвени"). Записано "3" (напр. сервитьорски монитор,
// чийто потребител после е станал шпикер) се чете като "2".
export const shpickerVisibleFromOf = (
  visibleFromStatus: unknown,
  showAllStatuses = false,
): KitchenStatus => {
  if (!isKitchenStatus(visibleFromStatus)) return showAllStatuses ? "0" : "2";
  return visibleFromStatus > SHPICKER_LAST_VISIBLE_FROM
    ? SHPICKER_LAST_VISIBLE_FROM
    : visibleFromStatus;
};

// „Вижда след" на сервитьорския екран: записаното ("0".."3" — и „Издадено",
// той не пише статуси); липсва (стар BE, старо огледало на касата) → "2".
const WAITER_VISIBLE_FROM_DEFAULT: KitchenStatus = "2";

export const waiterVisibleFromOf = (visibleFromStatus: unknown): KitchenStatus =>
  isKitchenStatus(visibleFromStatus) ? visibleFromStatus : WAITER_VISIBLE_FROM_DEFAULT;

// „Сервира след" на сервитьорския екран (прагът на монитора от BE); липсва →
// без ограничение.
export const serveFromStatusOf = (serveFromStatus: unknown): KitchenStatus =>
  isKitchenStatus(serveFromStatus) ? serveFromStatus : "0";
